// Fixed-label consent checkbox for informational emails

import CheckBox from './CheckBox';
import './ConsentCheckBox.scss';

export default function EmailConsentCheckBox({ value, onChange, disabled }) {
  return (
    <CheckBox
      label='I agree to receive informational emails'
      className='consent-check-box'
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  );
}
